import { create } from 'zustand';
import type { AppManifest, AppMeta, Asset } from '@scio3/shared-types';

export interface SmallAppEditorOptions {
  currentPath?: string | null;
  currentGroup?: { _id: string; teamId?: string; currentPath?: string } | null;
  onAssetSaved?: (asset: Partial<Asset>) => void;
  isCloseModalAfterSave?: boolean;
  /** Transient clone ID — when set, the iframe treats this as a clone operation */
  cloneId?: string | null;
  /** Engage wizard mode — sets engage=true and groupId=null before save mutation */
  isEngage?: boolean;
  /** Called with raw iframe form data during save — lets wizard capture fields not in the Asset record */
  onFormDataCapture?: (formData: Record<string, unknown>) => void;
}

interface SmallAppEditorState {
  isOpen: boolean;
  appMeta: AppMeta | null;
  /** null = add mode, existing asset = edit mode */
  asset: Partial<Asset> | null;
  options: SmallAppEditorOptions;
  /** Inline manifest — used by ManifestPlayground to pass manifest directly (bypasses API fetch) */
  inlineManifest: AppManifest | null;

  openEditor: (params: {
    appMeta: AppMeta;
    asset?: Partial<Asset> | null;
    options?: SmallAppEditorOptions;
    /** Pass manifest inline to bypass API fetch (used by ManifestPlayground) */
    inlineManifest?: AppManifest | null;
  }) => void;
  closeEditor: () => void;
}

export const useSmallAppEditorStore = create<SmallAppEditorState>((set) => ({
  isOpen: false,
  appMeta: null,
  asset: null,
  options: {},
  inlineManifest: null,

  openEditor: ({ appMeta, asset = null, options = {}, inlineManifest = null }) =>
    set({ isOpen: true, appMeta, asset, options, inlineManifest }),
  closeEditor: () =>
    set({ isOpen: false, appMeta: null, asset: null, options: {}, inlineManifest: null }),
}));
